import { render } from "./CoBrandThemeClassicSplit.vue?vue&type=template&id=75b5bde0&scoped=true"
import script from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassicSplit.vue?vue&type=style&index=0&id=75b5bde0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b5bde0"]])

export default __exports__